import ProfileCard from './profile-card'
export default ProfileCard
